import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
  HttpClientXsrfModule,
  HttpXsrfTokenExtractor
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { Router, RouterEvent, NavigationEnd } from '@angular/router';
import { Injectable } from "@angular/core";
import { AuthService } from "../services/auth.service";
import { filter, pairwise } from 'rxjs/operators';

const TOKEN_HEADER_KEY = 'x-access-token';
@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
  previousUrl: string;


  constructor(
    private router: Router,
    private tokenExtractor: HttpXsrfTokenExtractor
    ) {

router.events
  .pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd)
  )
  .subscribe(event => {
    this.previousUrl = event.url;
  });
   }



  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {


    request = request.clone({
      headers: request.headers.set("Accept", "application/json"),
    });

    const token = localStorage.getItem('token');

    if (token) {
         request = request.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
    }



    return next.handle(request).pipe(

      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          localStorage.clear();
          this.router.navigate(["auth/login"]);
        }
        return throwError(error);
      })
    );



  }


}
